import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
const LavenderSVG1 = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 120 350" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-112">
    <path d="M60 350 Q70 200 30 30" stroke="#8B9D77" strokeWidth="2.5" strokeLinecap="round" data-id="element-113" />
    <path d="M63 300 Q85 280 90 250 Q70 270 61 290" fill="#8B9D77" opacity="0.7" data-id="element-114" />
    <path d="M57 250 Q35 230 30 200 Q50 220 59 240" fill="#8B9D77" opacity="0.7" data-id="element-115" />
    <path d="M65 180 Q85 160 90 130 Q70 150 63 170" fill="#8B9D77" opacity="0.7" data-id="element-116" />
    <g opacity="0.85" data-id="element-117">
      <ellipse cx="45" cy="140" rx="4" ry="6" fill="#a78bfa" transform="rotate(20 45 140)" data-id="element-118" />
      <ellipse cx="52" cy="135" rx="3" ry="5" fill="#c084fc" transform="rotate(-15 52 135)" data-id="element-119" />
      <ellipse cx="55" cy="120" rx="4.5" ry="7" fill="#c084fc" transform="rotate(-25 55 120)" data-id="element-120" />
      <ellipse cx="48" cy="115" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(10 48 115)" data-id="element-121" />
      <ellipse cx="40" cy="100" rx="3.5" ry="6" fill="#d8b4fe" transform="rotate(30 40 100)" data-id="element-122" />
      <ellipse cx="47" cy="95" rx="4" ry="6" fill="#a78bfa" transform="rotate(-10 47 95)" data-id="element-123" />
      <ellipse cx="50" cy="80" rx="5" ry="8" fill="#a78bfa" transform="rotate(-20 50 80)" data-id="element-124" />
      <ellipse cx="42" cy="75" rx="3" ry="5" fill="#c084fc" transform="rotate(15 42 75)" data-id="element-125" />
      <ellipse cx="35" cy="60" rx="4" ry="6" fill="#c084fc" transform="rotate(25 35 60)" data-id="element-126" />
      <ellipse cx="42" cy="55" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-5 42 55)" data-id="element-127" />
      <ellipse cx="45" cy="40" rx="4.5" ry="7" fill="#a78bfa" transform="rotate(-30 45 40)" data-id="element-128" />
      <ellipse cx="38" cy="35" rx="3" ry="5" fill="#c084fc" transform="rotate(10 38 35)" data-id="element-129" />
      <ellipse cx="30" cy="25" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(20 30 25)" data-id="element-130" />
      <ellipse cx="35" cy="20" rx="2.5" ry="4" fill="#a78bfa" transform="rotate(-15 35 20)" data-id="element-131" />
    </g>
  </svg>;
const LavenderSVG2 = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 150 300" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-132">
    <path d="M75 300 Q60 150 90 20" stroke="#8B9D77" strokeWidth="2" strokeLinecap="round" data-id="element-133" />
    <path d="M70 200 Q40 150 30 80" stroke="#8B9D77" strokeWidth="1.5" strokeLinecap="round" data-id="element-134" />
    <path d="M73 260 Q50 250 40 220 Q60 240 71 250" fill="#8B9D77" opacity="0.7" data-id="element-135" />
    <path d="M74 180 Q100 170 110 140 Q90 160 76 170" fill="#8B9D77" opacity="0.7" data-id="element-136" />
    <g opacity="0.85" data-id="element-137">
      {/* Main Stem Flowers */}
      <ellipse cx="80" cy="120" rx="4" ry="6" fill="#c084fc" transform="rotate(-15 80 120)" data-id="element-138" />
      <ellipse cx="88" cy="115" rx="3" ry="5" fill="#a78bfa" transform="rotate(20 88 115)" data-id="element-139" />
      <ellipse cx="90" cy="100" rx="4.5" ry="7" fill="#a78bfa" transform="rotate(25 90 100)" data-id="element-140" />
      <ellipse cx="82" cy="95" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-10 82 95)" data-id="element-141" />
      <ellipse cx="75" cy="80" rx="3.5" ry="6" fill="#d8b4fe" transform="rotate(-25 75 80)" data-id="element-142" />
      <ellipse cx="83" cy="75" rx="4" ry="6" fill="#c084fc" transform="rotate(15 83 75)" data-id="element-143" />
      <ellipse cx="85" cy="60" rx="5" ry="8" fill="#c084fc" transform="rotate(20 85 60)" data-id="element-144" />
      <ellipse cx="77" cy="55" rx="3" ry="5" fill="#a78bfa" transform="rotate(-20 77 55)" data-id="element-145" />
      <ellipse cx="95" cy="40" rx="4" ry="6" fill="#a78bfa" transform="rotate(30 95 40)" data-id="element-146" />
      <ellipse cx="87" cy="35" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-5 87 35)" data-id="element-147" />
      <ellipse cx="88" cy="20" rx="3" ry="5" fill="#d8b4fe" transform="rotate(15 88 20)" data-id="element-148" />

      {/* Side Stem Flowers */}
      <ellipse cx="45" cy="140" rx="3.5" ry="5" fill="#a78bfa" transform="rotate(-20 45 140)" data-id="element-149" />
      <ellipse cx="38" cy="135" rx="2.5" ry="4" fill="#d8b4fe" transform="rotate(15 38 135)" data-id="element-150" />
      <ellipse cx="35" cy="120" rx="4" ry="6" fill="#d8b4fe" transform="rotate(-30 35 120)" data-id="element-151" />
      <ellipse cx="42" cy="115" rx="3" ry="5" fill="#c084fc" transform="rotate(10 42 115)" data-id="element-152" />
      <ellipse cx="40" cy="100" rx="3" ry="5" fill="#c084fc" transform="rotate(-15 40 100)" data-id="element-153" />
      <ellipse cx="33" cy="95" rx="2.5" ry="4" fill="#a78bfa" transform="rotate(25 33 95)" data-id="element-154" />
      <ellipse cx="28" cy="80" rx="3.5" ry="5" fill="#a78bfa" transform="rotate(-25 28 80)" data-id="element-155" />
    </g>
  </svg>;
const LavenderSVG3 = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 100 250" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-156">
    <path d="M50 250 Q55 120 45 10" stroke="#8B9D77" strokeWidth="2.5" strokeLinecap="round" data-id="element-157" />
    <path d="M51 200 Q70 190 75 160 Q60 180 52 190" fill="#8B9D77" opacity="0.7" data-id="element-158" />
    <path d="M49 150 Q30 140 25 110 Q40 130 48 140" fill="#8B9D77" opacity="0.7" data-id="element-159" />
    <g opacity="0.9" data-id="element-160">
      <ellipse cx="40" cy="90" rx="4" ry="6" fill="#a78bfa" transform="rotate(-20 40 90)" data-id="element-161" />
      <ellipse cx="48" cy="88" rx="3" ry="5" fill="#c084fc" transform="rotate(15 48 88)" data-id="element-162" />
      <ellipse cx="55" cy="85" rx="5" ry="7" fill="#c084fc" transform="rotate(25 55 85)" data-id="element-163" />
      <ellipse cx="47" cy="80" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-10 47 80)" data-id="element-164" />
      <ellipse cx="45" cy="75" rx="4.5" ry="6" fill="#d8b4fe" transform="rotate(-15 45 75)" data-id="element-165" />
      <ellipse cx="52" cy="70" rx="3" ry="5" fill="#a78bfa" transform="rotate(20 52 70)" data-id="element-166" />
      <ellipse cx="35" cy="65" rx="3.5" ry="5" fill="#a78bfa" transform="rotate(-30 35 65)" data-id="element-167" />
      <ellipse cx="43" cy="62" rx="2.5" ry="4" fill="#c084fc" transform="rotate(10 43 62)" data-id="element-168" />
      <ellipse cx="52" cy="60" rx="4" ry="6" fill="#c084fc" transform="rotate(20 52 60)" data-id="element-169" />
      <ellipse cx="45" cy="55" rx="3" ry="5" fill="#a78bfa" transform="rotate(-15 45 55)" data-id="element-170" />
      <ellipse cx="42" cy="50" rx="5" ry="7" fill="#a78bfa" transform="rotate(-25 42 50)" data-id="element-171" />
      <ellipse cx="50" cy="45" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(15 50 45)" data-id="element-172" />
      <ellipse cx="50" cy="40" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(20 50 40)" data-id="element-173" />
      <ellipse cx="42" cy="35" rx="2.5" ry="4" fill="#c084fc" transform="rotate(-10 42 35)" data-id="element-174" />
      <ellipse cx="38" cy="30" rx="4" ry="6" fill="#c084fc" transform="rotate(-30 38 30)" data-id="element-175" />
      <ellipse cx="45" cy="25" rx="3" ry="5" fill="#a78bfa" transform="rotate(15 45 25)" data-id="element-176" />
      <ellipse cx="48" cy="20" rx="3" ry="5" fill="#a78bfa" transform="rotate(25 48 20)" data-id="element-177" />
      <ellipse cx="43" cy="10" rx="2.5" ry="4" fill="#d8b4fe" transform="rotate(-15 43 10)" data-id="element-178" />
    </g>
  </svg>;
export function LavenderBranches() {
  const {
    scrollYProgress
  } = useScroll();
  // Different parallax speeds for depth
  const y1 = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, -250]);
  const y3 = useTransform(scrollYProgress, [0, 1], [0, -100]);
  const y4 = useTransform(scrollYProgress, [0, 1], [0, -300]);
  return <div className="fixed inset-y-0 left-0 right-0 z-[2] pointer-events-none hidden xl:block overflow-hidden" data-id="element-179">
      {/* Left side branches */}
      <motion.div style={{
      y: y1
    }} className="absolute top-[10%] -left-10 w-48 opacity-60 blur-[0.5px]" data-id="element-180">
        <motion.div animate={{
        rotate: [-2, 2, -2]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-181">
          <LavenderSVG1 className="w-full h-auto" data-id="element-182" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y2
    }} className="absolute top-[40%] -left-16 w-64 opacity-40 blur-[1px]" data-id="element-183">
        <motion.div animate={{
        rotate: [1, -2, 1]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-184">
          <LavenderSVG2 className="w-full h-auto" data-id="element-185" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y3
    }} className="absolute top-[75%] -left-6 w-40 opacity-70" data-id="element-186">
        <motion.div animate={{
        rotate: [-1, 3, -1]
      }} transition={{
        duration: 9,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-187">
          <LavenderSVG3 className="w-full h-auto" data-id="element-188" />
        </motion.div>
      </motion.div>

      {/* Right side branches (mirrored) */}
      <motion.div style={{
      y: y4
    }} className="absolute top-[5%] -right-12 w-56 opacity-50 blur-[0.5px] scale-x-[-1]" data-id="element-189">
        <motion.div animate={{
        rotate: [-2, 2, -2]
      }} transition={{
        duration: 11,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-190">
          <LavenderSVG2 className="w-full h-auto" data-id="element-191" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y1
    }} className="absolute top-[45%] -right-8 w-48 opacity-70 scale-x-[-1]" data-id="element-192">
        <motion.div animate={{
        rotate: [2, -1, 2]
      }} transition={{
        duration: 8.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-193">
          <LavenderSVG1 className="w-full h-auto" data-id="element-194" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y2
    }} className="absolute top-[80%] -right-16 w-64 opacity-40 blur-[1px] scale-x-[-1]" data-id="element-195">
        <motion.div animate={{
        rotate: [-3, 1, -3]
      }} transition={{
        duration: 12,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-196">
          <LavenderSVG3 className="w-full h-auto" data-id="element-197" />
        </motion.div>
      </motion.div>
    </div>;
}